module.exports = {
	testListing: '/',
	invitations: '/:tid/invitations'
};
